import axios from '../utils/axios';
import {
  LOADING_USERS,
  GET_USERS,
  UPDATE_USER,
  DELETE_USER,
  INVITE_USER,
  GET_USER_STEPS,
} from './types';

export const getUsers = () => async (dispatch) => {
  try {
    // set users loading
    dispatch({
      type: LOADING_USERS,
      payload: { field: 'loadingUsers', value: true },
    });
    // make request to fetch users
    const { data } = await axios.get('/users', {
      params: {
        role: 'User',
        isDeleted: false,
      },
    });
    // set users in store
    dispatch({ type: GET_USERS, payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const updateUser = (id, user, cb) => async (dispatch) => {
  try {
    // set deleting user
    dispatch({
      type: LOADING_USERS,
      payload: { field: 'updatingUser', value: true },
    });
    // make a request to update user
    const res = await axios.patch(`/users/${id}`, user);
    // update user in store
    dispatch({ type: UPDATE_USER, payload: res.data });
    // respond with success message
    cb({
      type: 'success',
      statusCode: res.status,
      message: 'User updated successfully',
    });
  } catch (error) {
    // respond with error message
    const { response } = error;
    cb({
      type: 'error',
      statusCode: response.status,
      message: response.data.message,
    });
    console.log(error);
  } finally {
    // set inviting user loading to false
    dispatch({
      type: LOADING_USERS,
      payload: { field: 'updatingUser', value: false },
    });
  }
};

export const deleteUser = (id) => async (dispatch) => {
  try {
    // set deleting user
    dispatch({
      type: LOADING_USERS,
      payload: { field: 'deletingUser', value: true },
    });
    // make a DELETE request
    await axios.delete(`/users/${id}`);
    // remove user from store
    dispatch({ type: DELETE_USER, payload: id });
  } catch (error) {
    console.log(error);
  }
};

export const inviteUser = (user, cb) => async (dispatch) => {
  try {
    // set inviting user loading
    dispatch({
      type: LOADING_USERS,
      payload: { field: 'loadingInviteUser', value: true },
    });
    // make a request to create user
    const res = await axios.post(`/users`, user);
    delete res.data.role;
    // push newly created user to store
    dispatch({ type: INVITE_USER, payload: res.data });
    // responde with success message
    cb({
      type: 'success',
      statusCode: res.status,
      message: 'User created successfully',
    });
  } catch (error) {
    // respond with error message
    const { response } = error;
    cb({
      type: 'error',
      statusCode: response.status,
      message: response.data.message,
    });
  } finally {
    // set inviting user loading to false
    dispatch({
      type: LOADING_USERS,
      payload: { field: 'loadingInviteUser', value: false },
    });
  }
};

export const getUserSteps =
  ({ userId, page = 0, limit = 50 }) =>
  async (dispatch) => {
    try {
      // set user steps loading
      dispatch({
        type: LOADING_USERS,
        payload: { field: 'loadingUserSteps', value: true },
      });
      // make a request to fetch user steps
      const response = await axios.get(`/steps-data`, {
        params: {
          userId,
          page,
          limit,
        },
      });
      // set steps in store
      dispatch({ type: GET_USER_STEPS, payload: response.data });
    } catch (error) {
      console.log(error);
    }
  };

export const resendInvitation = (id) => async (dispatch) => {
  try {
    // set resend invitation loading
    dispatch({
      type: LOADING_USERS,
      payload: { field: 'resendingInvitation', value: true },
    });

    await axios.patch(`/users/${id}/resend-google-link`);

    dispatch({
      type: LOADING_USERS,
      payload: { field: 'resendingInvitation', value: false },
    });
  } catch (error) {
    console.log(error);
  }
};

export const exportData = (id) => async (dispatch) => {
  try {
    // set export data loading
    dispatch({
      type: LOADING_USERS,
      payload: { field: 'exportingData', value: true },
    });

    const response = await axios.get(`/exporter/?userId=${id}`);
    let a = document.createElement('a');
    const file = new Blob([response.data], { type: 'text/csv' });
    a.href = URL.createObjectURL(file);
    a.download = `${id}.csv`;
    a.click();

    a.remove();

    dispatch({
      type: LOADING_USERS,
      payload: { field: 'exportingData', value: false },
    });
  } catch (error) {
    console.log(error);
  }
};

export const RefetchData = (id) => async (dispatch) => {
  // set refetching data loading
  dispatch({
    type: LOADING_USERS,
    payload: { field: 'refetchingData', value: true },
  });

  await axios.patch(`/google-fit/recalculate?userId=${id}`);

  dispatch({
    type: LOADING_USERS,
    payload: { field: 'refetchingData', value: false },
  });
};
